import React from "react";
import { FaAngleRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Card.css";

function Card({ icon, title, description, slug, userRedcashValue }) {
  return (
    <div className="dashboard__card-container">
      <div className="dashboard__card">
        <img src={icon} alt="Credit Card Icon" />
        <Link
          to={{ pathname: slug, state: { userRedcashValue: userRedcashValue } }}
        >
          <h1>
            {title} <FaAngleRight />
          </h1>
        </Link>

        <p>{description}</p>
      </div>
    </div>
  );
}

export default Card;
